import {useState, useEffect} from "react";
import Location from "../../Assets/images/location.svg";
import Call from "../../Assets/images/call.svg";
import Clock from "../../Assets/images/clock.svg";
import "./CallWithUs.scss";
import Title from "../Title/Title";
import {Link} from "react-router-dom";
import IconViewer from "../../Assets/svg/IconViewer";
import {toast} from "react-toastify";
import axios from "axios";
import {prefixUrl} from "../../Utils/utilsData";
import Loader from "../Loader/Loader";

const CallWithUs = () => {
  const [data, setData] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [isLoad, setIsLoad] = useState(false)
  const [iconLink, setIconLink] = useState([])

  useEffect(() => {
    if (!dataFetched) {
      axios.get(`${prefixUrl()}/contactUS.php`)
        .then((res) => {
          if (res.data.status) {
            setData(res.data.output);
            setDataFetched(true);
            setIsLoad(true)
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });

      axios.get(`${prefixUrl()}/footer.php`)
        .then((res) => {
          if (res.data.status) {
            setIconLink(res.data.data.footerLink)
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });

    }
  }, [dataFetched]);

  debugger
  return (
    <div>
      {isLoad ?
        <div className="columnCallWithUs">
          <div className="columnCallUs">
            <div className="Title">
              <Title englishTitle={""} title={"تماس با ما"}/>
            </div>
            <div className="underCallWithUs">

              {data?.map((pair, index) => (
                <div className="Call">
                  <div className="imageCall">
                    <img src={pair.image} alt="Call"/>
                  </div>
                  <div className="rowCall">
                    <span className="Call">{pair.titlePersian + ":"}</span>
                    <span className="CallNum">{pair?.value}</span>
                  </div>
                </div>
              ))}

              <div className="box-row-icon">
                <div className="RowSocialMediaFooter">
                  {iconLink?.map((item, index) => (<div key={index}>
                    <Link to={item?.link}>
                      <img src={item?.icon} alt={item?.title}/>
                    </Link>
                  </div>))}
                </div>
              </div>

            </div>
          </div>
        </div>
        : <Loader/>}
    </div>
  );
};

export default CallWithUs;
